export const PRODUCT_NAMES = { hexcore: 'HexCore Pro', profoam: 'ProFoam Pro' };

export const SOURCE_LABEL = {
  walk_in: 'Bought at the court', whatsapp: 'Shared on WhatsApp', instagram: 'Shared on Instagram',
  amazon: 'Amazon buyer', phone: 'Shared by phone', email: 'Shared by email', event: 'Met at an event',
  online: 'Ordered on dyssc.com',
};

export const productLabel = (r) => PRODUCT_NAMES[r.product_slug] || (r.product_name || '').replace(/^DYSSC\s+/i, '') || 'DYSSC paddle';

export const fmtDate = (iso) => {
  const d = iso ? new Date(iso) : null;
  return d && !Number.isNaN(d.getTime())
    ? d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
    : '';
};

export const MANIFESTO = [
  { n: '01', title: 'Real players, real orders', text: 'Every "order verified" review is matched to an actual DYSSC order before it goes live.' },
];

export const waReviewLink = (number, product) =>
  `https://wa.me/${number}?text=${encodeURIComponent(`Hi DYSSC! Here's my honest review of my ${product || 'DYSSC paddle'}: `)}`;
